import React from 'react';
import Icon from '../../../components/AppIcon';

const StatsCards = ({ stats }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-2 mb-4">
      <div className="bg-card border border-border rounded-lg p-2">
        <div className="flex items-center justify-between mb-0.5">
          <p className="text-[11px] font-medium text-muted-foreground">Total Tests</p>
          <div className="p-1 bg-blue-100 rounded-md">
            <Icon name="FlaskConical" size={14} className="text-blue-600" />
          </div>
        </div>
        <p className="text-xl font-bold text-foreground">{stats?.total || 0}</p>
      </div>

      <div className="bg-card border border-border rounded-lg p-2">
        <div className="flex items-center justify-between mb-0.5">
          <p className="text-[11px] font-medium text-muted-foreground">Active</p>
          <div className="p-1 bg-green-100 rounded-md">
            <Icon name="Play" size={14} className="text-green-600" />
          </div>
        </div>
        <p className="text-xl font-bold text-foreground">{stats?.active || 0}</p>
      </div>

      <div className="bg-card border border-border rounded-lg p-2">
        <div className="flex items-center justify-between mb-0.5">
          <p className="text-[11px] font-medium text-muted-foreground">Completed</p>
          <div className="p-1 bg-purple-100 rounded-md">
            <Icon name="CheckCircle2" size={14} className="text-purple-600" />
          </div>
        </div>
        <p className="text-xl font-bold text-foreground">{stats?.completed || 0}</p>
      </div>

      <div className="bg-card border border-border rounded-lg p-2">
        <div className="flex items-center justify-between mb-0.5">
          <p className="text-[11px] font-medium text-muted-foreground">Paused</p>
          <div className="p-1 bg-gray-100 rounded-md">
            <Icon name="Pause" size={14} className="text-gray-600" />
          </div>
        </div>
        <p className="text-xl font-bold text-foreground">{stats?.paused || 0}</p>
      </div>
    </div>
  );
};

export default StatsCards;